import * as React from "react";
import {useRef} from "react";
import {useLegacyCombobox} from "@/shared/ui/compatibility/useLegacyCombobox";

interface ComboboxInputProps<T extends {id: string | number}> {
	id: string;
	name?: string;
	value: T | null;
	items: T[];
	onValueChange: (value: T | null) => void;
	formatter: (item: T) => string;
	disabled?: boolean;
	clearable?: boolean;
	emptyMessage?: string;
	className?: string;
	caretClassName?: string;
	caretButtonClassName?: string;
}

export function ComboboxInput<T extends {id: string | number}>({
	id,
	name,
	value,
	items,
	onValueChange,
	formatter,
	disabled = false,
	clearable = false,
	emptyMessage = "",
	className,
	caretClassName = "fas fa-caret-down",
	caretButtonClassName,
}: ComboboxInputProps<T>) {
	const filterRef = useRef<HTMLInputElement>(null);
	const idRef = useRef<HTMLInputElement>(null);
	const caretRef = useRef<HTMLButtonElement>(null);

	useLegacyCombobox({
		idRef,
		filterRef,
		caretRef,
		items,
		value,
		formatter,
		onValueChange,
		clearable,
		disabled,
		emptyMessage,
	});

	return (
		<div className="input-group">
			<input ref={idRef} type="hidden" name={name} />
			<input
				ref={filterRef}
				id={id}
				type="text"
				className={["form-control", className].filter(Boolean).join(" ")}
			/>
			<span className="input-group-btn">
				<button
					ref={caretRef}
					type="button"
					className={["btn btn-default btn-icon", caretButtonClassName].filter(Boolean).join(" ")}
					tabIndex={-1}
					disabled={disabled}
				>
					<i className={caretClassName} />
				</button>
			</span>
		</div>
	);
}

export type {ComboboxInputProps};
